export namespace SpiderchartXAxis {
  export enum Type {
    EMPTY,
    TECHNICAL_STATE,
    ROADMAP_INDICATOR,
  }

  interface BaseConfiguration {
    type: Type;
    undisplayed?: boolean;
  }

  export interface EmptyConfiguration extends BaseConfiguration {
    type: Type.EMPTY;
  }

  export interface TechnicalStateConfiguration extends BaseConfiguration {
    type: Type.TECHNICAL_STATE;
    superCategory?: number;
    category?: number;
    subCategory?: number;
    assetType?: number;
  }

  export interface RoadmapIndicatorConfiguration extends BaseConfiguration {
    type: Type.ROADMAP_INDICATOR;
    roadmapIndicator: number;
  }

  export type Configuration = EmptyConfiguration | TechnicalStateConfiguration | RoadmapIndicatorConfiguration;

  export interface Instance {
    label: string;
    data: number[];
    type: Type;
    auditYear?: number;
    projectedYear?: number;
    benchmarkData: number[];
    /** Link is formatted to be used by router.navigate */
    link?: (string | number)[];
  }
}
